var $cart,
    $menuContainerTop,
    $menuContainerMobile;

$(document).ready(function($) {
    $cart = $('.js-cart');
    $menuContainerTop = $('.js-login-menu');
    $menuContainerMobile = $('.js-login-menu-mobile');

    getCartAmount();
    GetMenu();
    initLogoUpload();
    initProductLogoUpload();
});


function getCartAmount() {
    jQuery.ajax({
        url : linku_ajax_url,
        type : 'post',
        data : {
            action : 'load_cart_amount',
        },
        dataType: 'json',
        success : function( response ) {
            if (typeof response.cart_amount !== 'undefined') {
                AddAmountToCart(response.cart_amount);
            }
        }
    });
}

function GetMenu() {
    jQuery.ajax({
        url : linku_ajax_url,
        type : 'post',
        data : {
            action : 'get_login_menu',
        },
        dataType: 'json',
        success : function( response ) {
            if (typeof response.htmlTop !== 'undefined') {
                $menuContainerTop.replaceWith(response.htmlTop);
            }

            if (typeof response.htmlMobile !== 'undefined') {
                $menuContainerMobile.replaceWith(response.htmlMobile);
            }
        }
    });
}



function AddAmountToCart(cart_amount) {
    if (cart_amount && cart_amount !== 0) {
        $cart.append(' <span class="c-cart__amount">'+cart_amount+'</span>')
    }
}

function initLogoUpload() {
    $(document).on('change', '.js-logo-upload', function() {
        const $input = $(this);
        const file = this.files[0];
        const cartItemKey = $input.data('cart-item');
        const productId = $input.data('product-id');
        
        if (!file) return;
        
        // Validate file type
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf', 'application/postscript'];
        if (allowedTypes.indexOf(file.type) === -1) {
            alert('Bestandstype niet toegestaan. Alleen JPG, PNG, GIF, PDF, EPS en AI bestanden zijn toegestaan.');
            return;
        }
        
        // Validate file size (10MB)
        if (file.size > 10 * 1024 * 1024) {
            alert('Bestand is te groot. Maximum grootte is 10MB.');
            return;
        }
        
        const $container = $input.closest('.c-cart-item__logo-upload');
        const $progress = $container.find('.upload-progress');
        const $progressFill = $container.find('.progress-fill');
        
        // Show progress
        $progress.show();
        
        const formData = new FormData();
        formData.append('action', 'upload_cart_logo');
        formData.append('logo_file', file);
        formData.append('cart_item_key', cartItemKey);
        formData.append('product_id', productId);
        formData.append('nonce', woo_cart_nonce);
        
        jQuery.ajax({
            url: linku_ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            xhr: function() {
                const xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function(evt) {
                    if (evt.lengthComputable) {
                        const percentComplete = evt.loaded / evt.total * 100;
                        $progressFill.css('width', percentComplete + '%');
                    }
                }, false);
                return xhr;
            },
            success: function(response) {
                $progress.hide();
                if (response.success) {
                    // Update the UI with the uploaded file
                    const $wrapper = $container.find('.logo-upload-wrapper');
                    let $existingLogo = $wrapper.find('.existing-logo');
                    
                    if ($existingLogo.length === 0) {
                        $existingLogo = $('<div class="existing-logo"></div>').prependTo($wrapper);
                    }
                    
                    $existingLogo.html(`
                        <img src="${response.data.url}" alt="Uploaded logo" class="logo-preview">
                        <p class="logo-filename">${response.data.name}</p>
                    `);
                    
                    // Update button text
                    $container.find('.logo-upload-btn').text('Vervang logo');
                    
                    // Trigger cart update
                    $('body').trigger('wc_update_cart');
                } else {
                    alert(response.data.message || 'Er is een fout opgetreden bij het uploaden.');
                }
            },
            error: function() {
                $progress.hide();
                alert('Er is een fout opgetreden bij het uploaden.');
            }
        });
    });
}

function initProductLogoUpload() {
    $(document).on('change', '.js-product-logo-upload', function() {
        const $input = $(this);
        const file = this.files[0];
        const productId = $input.data('product-id');
        
        if (!file) return;
        
        // Validate file type
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf', 'application/postscript'];
        if (allowedTypes.indexOf(file.type) === -1) {
            alert('Bestandstype niet toegestaan. Alleen JPG, PNG, GIF, PDF, EPS en AI bestanden zijn toegestaan.');
            return;
        }
        
        // Validate file size (10MB)
        if (file.size > 10 * 1024 * 1024) {
            alert('Bestand is te groot. Maximum grootte is 10MB.');
            return;
        }
        
        const $container = $input.closest('.c-product-logo-upload');
        const $progress = $container.find('.upload-progress');
        const $progressFill = $container.find('.progress-fill');
        
        // Show progress
        $progress.show();
        
        const formData = new FormData();
        formData.append('action', 'upload_product_logo');
        formData.append('logo_file', file);
        formData.append('product_id', productId);
        formData.append('nonce', woo_product_nonce);
        
        jQuery.ajax({
            url: linku_ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            xhr: function() {
                const xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function(evt) {
                    if (evt.lengthComputable) {
                        const percentComplete = evt.loaded / evt.total * 100;
                        $progressFill.css('width', percentComplete + '%');
                    }
                }, false);
                return xhr;
            },
            success: function(response) {
                $progress.hide();
                if (response.success) {
                    // Update the UI with the uploaded file
                    const $wrapper = $container.find('.logo-upload-wrapper');
                    let $existingLogo = $wrapper.find('.existing-logo');
                    
                    if ($existingLogo.length === 0) {
                        $existingLogo = $('<div class="existing-logo"></div>').prependTo($wrapper);
                    }
                    
                    $existingLogo.html(`
                        <img src="${response.data.url}" alt="Uploaded logo" class="logo-preview">
                        <p class="logo-filename">${response.data.name}</p>
                    `);
                    
                    // Update button text
                    $container.find('.logo-upload-btn').text('Vervang logo');
                } else {
                    alert(response.data.message || 'Er is een fout opgetreden bij het uploaden.');
                }
            },
            error: function() {
                $progress.hide();
                alert('Er is een fout opgetreden bij het uploaden.');
            }
        });
    });
}
